<template>
  <DashboardChartWrapper
    title="Activite des clients"
    :loading="loading"
    :error="error"
    @retry="refresh"
  >
    <template #controls>
      <GroupBySelect v-model="groupBy" />
    </template>
    <Bar v-if="chartData" :data="chartData" :options="chartOptions" />
  </DashboardChartWrapper>
</template>

<script setup>
import { ref, computed } from 'vue'
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import DashboardChartWrapper from './DashboardChartWrapper.vue'
import GroupBySelect from './GroupBySelect.vue'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const { dateParams } = useDateRange()
const groupBy = ref('month')

const params = computed(() => ({
  ...dateParams.value,
  group_by: groupBy.value
}))

const { data, loading, error, refresh } = useDashboard('/dashboard/charts/customer-activity', params)

const chartData = computed(() => {
  if (!data.value || !Array.isArray(data.value)) return null
  return {
    labels: data.value.map(d => d.label),
    datasets: [
      {
        label: 'Clients uniques',
        data: data.value.map(d => d.unique_customers),
        backgroundColor: '#3b82f6',
        borderRadius: 4
      },
      {
        label: 'Commandes',
        data: data.value.map(d => d.total_orders),
        backgroundColor: '#10b981',
        borderRadius: 4
      }
    ]
  }
})

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top', labels: { usePointStyle: true, pointStyle: 'circle' } }
  },
  scales: {
    y: { beginAtZero: true }
  }
}
</script>
